import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMoneybag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMoneybag"><Path d="M9.34375 7.5H14.6562M9.34375 7.5C9.34375 7.5 3.49996 10.9444 3.5 16.2222C3.50003 20.4663 7.72801 21.5 12 21.5C16.272 21.5 20.5 20.4663 20.5 16.2222C20.5 10.9444 14.6562 7.5 14.6562 7.5M9.34375 7.5L7.75 3.55556C7.75 3.55556 9.34375 2.5 12 2.5C14.6562 2.5 16.25 3.55556 16.25 3.55556L14.6562 7.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconMoneybag;
